/**
 * change javascript long floating numbers to two digit after decimal point
 */
export function roundToTwoDec(num: number): number {
    return Number.parseFloat(num.toFixed(2));
}
